import { render } from "./ToyPage.vue?vue&type=template&id=2d58c228&scoped=true"
import script from "./ToyPage.vue?vue&type=script&lang=js"
export * from "./ToyPage.vue?vue&type=script&lang=js"

import "./ToyPage.vue?vue&type=style&index=0&id=2d58c228&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d58c228"]])

export default __exports__